@if ($role | async; as role) {
  @if (enableNDBXStyles(role)) {
    <ps20-shop-ndbx-design></ps20-shop-ndbx-design>
  }
  @if (enableExpertStyles(role)) {
    <ps20-shop-expert-mode-design></ps20-shop-expert-mode-design>
  }
}
